import { render, staticRenderFns } from "./DocumentDetailList13.vue?vue&type=template&id=00094a60&scoped=true"
import script from "./DocumentDetailList13.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00094a60",
  null
  
)

export default component.exports